export default __webpack_public_path__ + "static/media/airport.4ba8ff26.svg";